import type { ComposerTranslation } from 'vue-i18n'

/** 与端口管理接口 system_type 一致：2 = Linux */
export const PORT_MANAGE_LINUX_SYSTEM_TYPE = 2

/**
 * 已知风险端口说明：`system_type === 2` 使用 `portManage.linuxRiskPortMap`，否则 `portManage.riskPortMap`。
 * 无对应 i18n key 时回落为接口返回的 `risk_detail`。
 */
export function getRiskPortDisplayText (
  t: ComposerTranslation,
  te: (key: string) => boolean,
  portNum: number | undefined | null,
  systemType: number | undefined | null,
  fallbackRiskDetail?: string | null | undefined
): string {
  const pn = Number(portNum)
  if (!Number.isFinite(pn)) {
    return fallbackRiskDetail ?? ''
  }
  const prefix = systemType === PORT_MANAGE_LINUX_SYSTEM_TYPE
    ? 'portManage.linuxRiskPortMap'
    : 'portManage.riskPortMap'
  const key = `${prefix}.${pn}`
  if (te(key)) {
    return String(t(key))
  }
  return fallbackRiskDetail ?? ''
}

/** 阻断规则可能是端口区间；仅单端口时走 i18n 映射 */
export function getRiskPortDisplayTextForPortRange (
  t: ComposerTranslation,
  te: (key: string) => boolean,
  portStart: number | undefined | null,
  portEnd: number | undefined | null,
  systemType: number | undefined | null,
  fallbackRiskDetail?: string | null | undefined
): string {
  const ps = Number(portStart)
  const pe = Number(portEnd)
  if (!Number.isFinite(ps) || !Number.isFinite(pe) || ps !== pe) {
    return fallbackRiskDetail ?? ''
  }
  return getRiskPortDisplayText(t, te, ps, systemType, fallbackRiskDetail)
}
